<template>
	<DialogFormDialog ref="dialog" class="form" :strings="strings" @reset="reset">
		<div class="form-row">
			<span>If device</span>
			<v-select
				v-model="selectedDevice"
				:items="devicesWithVariables"
				:rules="rules"
				@change="values.path = null"
			/>
		</div>

		<div class="form-row">
			<span>Has</span>
			<v-select v-model="values.path" :items="variables" :rules="rules" />
		</div>

		<div v-if="values.path" class="form-row three-column">
			<span>Value</span>

			<v-select
				v-if="!isBoolean"
				v-model="values.operator"
				:items="operators"
				:rules="rules"
			/>
			<k4-model-value-field
				v-model="values.value"
				:node="selectedDevice"
				:subpath="variableSubpath"
			/>
		</div>
		<div v-else class="form-row">
			<span>Value</span>
			<v-text-field :rules="rules" disabled />
		</div>
	</DialogFormDialog>
</template>

<style lang="scss" scoped>
.form-row {
	display: grid;
	grid-template-columns: minmax(50px, auto) auto;
	grid-template-rows: 1fr;
	place-items: center stretch;
}

.form-row.three-column {
	grid-template-columns: minmax(50px, auto) min-content auto;
}

span {
	font-weight: bold;
	margin-right: 12px;
}
</style>

<script>
import _ from "lodash";

import { DEFAULT_OPERATORS_MAP } from "@/services/k4/node/conditionNode";
import strings from "@/utils/strings";

const initData = () => ({
	operators: _.map(DEFAULT_OPERATORS_MAP, (val, key) => ({
		text: val,
		value: key,
	})),

	selectedDevice: null,
	values: {
		guid: null,
		path: null,
		operator: "==",
		value: "",
	},
});

export default {
	data: initData,

	computed: {
		strings() {
			const _strings = strings.live.scenes.varConditionDialog;
			return this.values.guid ? _strings.update : _strings.new;
		},

		rules() {
			return [(val) => !!val || "Required"];
		},

		devicesWithVariables() {
			return _.map(
				this.$store.getters["controller/nodes/devicesByType"]("variables"),
				(node) => ({
					text: _.startCase(
						`${node.path.split("/").reverse()[1]} ${node.name}`
					),
					value: node,
				})
			);
		},

		variables() {
			if (!this.selectedDevice) return [];

			const devicePath = this.selectedDevice.path;
			let variables = _.get(this.selectedDevice, "variables", []);
			variables = _.keys(variables);
			variables = _.map(variables, (variableName) => ({
				text: _.startCase(variableName),
				value: `${devicePath}/variables/${variableName}`,
			}));
			return variables;
		},

		variableSubpath() {
			if (!this.selectedDevice || !this.values.path) return "";

			const devicePath = this.selectedDevice.path;
			const varPath = this.values.path;
			return varPath.substr(devicePath.length + 1);
		},

		isBoolean() {
			const varNode = this.$store.getters["controller/nodes/liveNodeByPath"](
				this.values.path
			);
			const meta = varNode ? varNode.meta() : null;
			const type = _.get(meta, "type");
			return type === "boolean";
		},
	},

	watch: {
		variableSubpath(newVal, oldVal) {
			if (oldVal !== "" && newVal !== oldVal) {
				this.values.operator = "==";
				this.values.value = "";
			}
		},

		values: {
			deep: true,
			handler(newVal) {
				this.$refs.dialog.updateFormData(newVal);
			},
		},
	},

	methods: {
		reset() {
			Object.assign(this, initData());
		},

		pop(handler, node) {
			if (node) {
				this.values.guid = node.guid;
				this.values.path = node.targetPath;
				this.values.operator = node.operator;
				this.values.value = node.value;

				// Get selected device from target event
				this.selectedDevice = this.$store.getters[
					"controller/nodes/nodeByGuid"
				](_.get(node, "target.parentDevice.guid"));
			}
			return this.$refs.dialog.pop(handler);
		},
	},
};
</script>
